module.exports = __webpack_public_path__ + "static/media/search-bg-01.84e81ffe.jpg";